module.exports = __webpack_public_path__ + "static/img/stafflogo.cb769c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stafflogo.svg
// module id = zoy1
// module chunks = 1